import React from "react";
import BlockWrapper from "../../Layout/BlockWrapper";
import RCPROSpecificQuestions from "./RCPROSpecificQuestions";
import categories from "../../../Forms/categories.json";
import useFormState from "../useFormState";

const RCPROSpecificInfoInputs = () => {
  const { formData } = useFormState();
  const company = {
    RCPRO: {
      ...formData.activiteInputs,
      ...formData.rcproSpecificInfoInputs,
    },
  };
  console.log("formData", formData);

  return (
    <>
      <BlockWrapper>
        <div className="d-flex flex-column pt-4" style={{ gap: 24 }}>
          {categories
            .filter((cat) =>
              formData.activiteInputs.secteursPro.includes(cat.id)
            )
            .map((category, ck) => {
              return (
                <div key={ck}>
                  <RCPROSpecificQuestions
                    company={company}
                    categoryId={category.id}
                  />
                </div>
              );
            })}
        </div>
      </BlockWrapper>
    </>
  );
};

export default RCPROSpecificInfoInputs;
